import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,

} from '@mui/material';

const BulkStatusChangeModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  selectedCount 
}) => {
  const [newProgress, setNewProgress] = useState('');

  const handleClose = () => {
    setNewProgress('');
    onClose();
  };

  const handleConfirm = () => {
    if (newProgress !== '') {
      onConfirm(parseInt(newProgress));
      handleClose();
    }
  };

  const progressOptions = [
    { value: 0, label: 'No iniciado (0%)' },
    { value: 50, label: 'En progreso (50%)' },
    { value: 100, label: 'Completado (100%)' }
  ];

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Cambiar estado (progreso)
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          Cambiar el progreso de <strong>{selectedCount}</strong> registro{selectedCount !== 1 ? 's' : ''} seleccionado{selectedCount !== 1 ? 's' : ''}:
        </DialogContentText>
        
        <FormControl fullWidth>
          <InputLabel>Nuevo progreso</InputLabel>
          <Select
            value={newProgress}
            label="Nuevo progreso"
            onChange={(e) => setNewProgress(e.target.value)}
          >
            {progressOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          color="primary"
          disabled={newProgress === ''}
        >
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkStatusChangeModal;